export default {
  "inviteBoxAdmin.title": "Agent Cashback Admin",
  "inviteBoxAdmin.thead.index": "#No",
  "inviteBoxAdmin.thead.id": "ID",
  "inviteBoxAdmin.thead.inviteUserNum": "InviteUserNum",
  "inviteBoxAdmin.thead.bonus": "Bonus",
  "inviteBoxAdmin.thead.withdrawLimitRatio": "WithdrawLimitRatio",
  "inviteBoxAdmin.thead.createTime": "CreateTime",
  "inviteBoxAdmin.thead.modifyTime": "ModifyTime",
  "inviteBoxAdmin.thead.operator": "Operator",

  "inviteBoxAdmin.thead.action": "Action",
  "inviteBoxAdmin.add": "Add",
  "inviteBoxAdmin.edit": "Edit",
  "inviteBoxAdmin.details": "Details",
  "inviteBoxAdmin.delete": "Delete",
};
